/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

'use es6';

import { useState, useCallback, useEffect, useRef } from 'react';
import { PopoverType } from 'rich-text-lib/constants/popover';
import AnchorInsertPopover from './AnchorInsertPopover';
import { scrollAnchorIntoViewIfNeeded } from '../utils/anchor';
import AnchorEditPopover from './AnchorEditPopover';
import { TEMP_ANCHOR_ATTRIBUTE } from '../constants/hsanchor';
import { jsx as _jsx } from "react/jsx-runtime";
function AnchorPopoverManager(props) {
  const {
    editor,
    onInsert,
    onUpdate,
    onAnchorRemove,
    insertTempAnchor,
    removeTempAnchors,
    fetchAnchors,
    eventKey
  } = props;
  const [target, setTarget] = useState(null);
  const [popoverType, setPopoverType] = useState(PopoverType.INSERT);
  const [anchorList, setAnchorList] = useState([]);
  const lastTarget = useRef(target);
  useEffect(() => {
    lastTarget.current = target;
  });
  useEffect(() => {
    fetchAnchors().then(setAnchorList);
  }, [fetchAnchors, target]);
  const handleRemove = useCallback(() => {
    if (lastTarget.current) {
      setTarget(null);
      removeTempAnchors();
    }
  }, [removeTempAnchors]);
  const handleInsert = (...args) => {
    onInsert(...args);
    setPopoverType(PopoverType.EDIT);
  };
  useEffect(() => {
    const handleHsNodeChange = ({
      element
    }) => {
      if (!element) {
        handleRemove();
        return;
      }
      if (lastTarget.current === element) {
        editor.fire('ToggleAnchorEditPopover', {
          shouldOpen: false
        });
      } else {
        setTarget(null);
        setPopoverType(element.hasAttribute(TEMP_ANCHOR_ATTRIBUTE) ? PopoverType.INSERT : PopoverType.EDIT);
        setTarget(element);
      }
    };
    editor.on(`hsNodeChange:${eventKey}`, handleHsNodeChange);
    return () => editor.off(`hsNodeChange:${eventKey}`, handleHsNodeChange);
  }, [editor, handleRemove, eventKey]);
  useEffect(() => {
    const handleOpenPopover = () => {
      const tempAnchor = insertTempAnchor();
      scrollAnchorIntoViewIfNeeded(editor, tempAnchor);
      setPopoverType(PopoverType.INSERT);
      setTarget(tempAnchor);
    };
    editor.on('OpenAnchorPopover', handleOpenPopover);
    return () => editor.off('OpenAnchorPopover');
  }, [editor, insertTempAnchor]);
  const sharedProps = {
    editor,
    target,
    // Fetch & pass in the list of existing anchors to prevent duplicates
    anchorList: target ? anchorList.map(anchor => anchor.id) : [],
    onRemove: handleRemove
  };
  return popoverType === PopoverType.INSERT ? /*#__PURE__*/_jsx(AnchorInsertPopover, Object.assign({}, sharedProps, {
    onInsert: handleInsert,
    removeTempAnchors: removeTempAnchors
  })) : /*#__PURE__*/_jsx(AnchorEditPopover, Object.assign({}, sharedProps, {
    onUpdate: onUpdate,
    onAnchorRemove: onAnchorRemove
  }));
}
export default AnchorPopoverManager;